import React, { useState, useEffect } from 'react';
import union from 'lodash/union';
import difference from 'lodash/difference';
import PropTypes from 'prop-types';
import Label from 'components/ui/form/label';
import { FormFieldError } from 'components/ui/index';
import FormRadioInput from 'components/ui/form/radio_input';
import FormGroup from 'components/ui/form/form_group';

const FormCheckBoxCollectionInput = ({
  label,
  input,
  collection,
  meta,
  inline = false,
}) => {
  const [selectedValues, setSelectedValues] = useState(input.value);

  useEffect(() => {
    input.onChange(selectedValues);
  }, [selectedValues]);

  useEffect(() => {
    setSelectedValues(input.value);
  }, [input.value]);

  const checked = (value) => {
    return selectedValues.includes(value);
  };

  const handleChange = (ev) => {
    if (checked(ev.target.value)) {
      setSelectedValues((prevValues) => [
        ...difference(prevValues, [ev.target.value]),
      ]);
    } else {
      setSelectedValues((prevValues) => [
        ...union(prevValues, [ev.target.value]),
      ]);
    }
  };

  return (
    <>
      <FormGroup className={meta.touched && meta.error ? 'is-invalid' : ''}>
        {label && (
          <Label
            className={`d-block ${meta.touched && meta.error && 'text-danger'}`}
          >
            {label}
          </Label>
        )}
        <div
          className={`${
            inline ? 'd-flex align-center inline-form-check' : ''
          } `}
        >
          {collection.map((item) => {
            return (
              <FormRadioInput
                key={item.value}
                input={{
                  name: input.name,
                  onChange: handleChange,
                }}
                checked={checked(item.value)}
                radioValue={item.value}
                label={item.label}
                type="checkbox"
              />
            );
          })}
        </div>
      </FormGroup>
      <FormFieldError meta={meta} />
    </>
  );
};

FormCheckBoxCollectionInput.defaultProps = {
  label: null,
  meta: {
    error: null,
    touched: false,
  },
};

FormCheckBoxCollectionInput.propTypes = {
  label: PropTypes.any,
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  collection: PropTypes.array.isRequired,
};

export default FormCheckBoxCollectionInput;
